import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { formatMoney, getInlineLoader } from "../Helpers";
import { MdAssignmentAdd, MdLocationPin, MdStar } from "react-icons/md";
import MobileInterface from "../MobileInterface";
import logo from '../assets/logo.png';
import { FaListUl, FaRegCreditCard, FaRegListAlt, FaRegUser } from "react-icons/fa";
import { PiHandDepositFill, PiMoneyWavy } from "react-icons/pi";
import { IoIosCart } from "react-icons/io";
import { RiBilibiliLine, RiBillLine, RiMessage2Line } from "react-icons/ri";
import { FaArrowsDownToPeople, FaMoneyBills, FaMoneyBillTrendUp, FaPeopleRoof } from "react-icons/fa6";
import { STR_FLOAT_LOAN_SERVICE, STR_INBOX, STR_MENU_MY_PURCHASES, STR_MENU_MY_SALES, STR_MENU_POST_CROPS, STR_NEARBY_AGENTS, STR_NEARBY_SUPER_AGENTS, STR_POST_ITEM, STR_REPORT_ANALYSIS, STR_REQUEST_CASH, STR_REQUEST_FLOAT, STR_REQUEST_FLOAT_CASH, STR_REQUESTS_FEED } from "../Strings";


export default function HomeMenu(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);

	const menuItemStyle = {
		padding: "15px",
		borderRadius: "10px"
	}
	const menuItemSize = 64;
	const menuItemClassnames = "mShadow3 text-secondary";
	const menuItemTitleStyle = {
		fontSize: "12px",
		fontFamily: "FontBold",
		marginTop: "5px",
	}

	async function init() {
		//run initializations here
		setReady(false);
		//..
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [])

	if (ready) {
		return (
			<div className="row" style={{ marginTop: "30px", marginBottom: "20px" }}>
				<div 
					className="col-4 text-center mb-4"
					onClick={() => {
						
						appContext.navTo({
							item: 'view',
							subItem: 'post-item',
						})
					}}
				>
					<MdAssignmentAdd
						size={menuItemSize}
						style={menuItemStyle}
						className={menuItemClassnames}
					/>

					<h6
						style={menuItemTitleStyle}
					>
						{STR_POST_ITEM[appContext.language]}
					</h6>
				</div>

				

				<div 
					className="col-4 text-center mb-4"
					onClick={() => {
						appContext.navTo({
							item: 'my-sales',
						})
					}}
				>
					<FaRegListAlt
						size={menuItemSize}
						style={menuItemStyle}
						className={menuItemClassnames}
					/>

					<h6
						style={menuItemTitleStyle}
					>
						{STR_MENU_MY_SALES[appContext.language]}
					</h6>
				</div>


				<div 
					className="col-4 text-center mb-4"
					onClick={() => {
						appContext.navTo({
							item: 'my-orders',
						})
					}}
				>
					<FaListUl
						size={menuItemSize}
						style={menuItemStyle}
						className={menuItemClassnames}
					/>

					<h6
						style={menuItemTitleStyle}
					>
						{STR_MENU_MY_PURCHASES[appContext.language]}
					</h6>
				</div>

				

				
			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}